// // Use $ instead of jQuery without replacing global $
(function ($) {
    // On DOM ready
    $(document).ready(function () {
       $('.showcase-overlay .close-icon').on('click', function (e) {
           $('.showcase-overlay').slideUp(400);
       })
    });


})(jQuery);